import {defineMessages} from 'react-intl';

/**
 * 확장 갤러리 분류 탭 (2026-08-10 신설).
 *
 * 왜: 확장이 41개인데 분류 없이 한 줄로 흘러내려서, 학생이 "AI로 사물을 알아보고 싶은데
 * 비슷한 카드 5개 중 뭘 눌러야 하지?"에 답을 못 찾았다. 기능이 부족한 게 아니라
 * 많은데 정리가 안 돼 **풍성함이 헷갈림으로 보이던** 상태.
 *
 * 분류 축은 허브(hub.cubroid.com)·서비스 런처와 **같은 기준**을 쓴다 —
 * 학생이 서비스를 오갈 때 같은 말이 같은 뜻이어야 하니까.
 * (스크래치 라이브러리가 태그 필터를 이미 지원해서, 각 카드에 tags 만 붙이면 된다.)
 */

const messages = defineMessages({
    hardware: {
        defaultMessage: 'Robot',
        description: 'Extension category: Cubroid hardware blocks',
        id: 'gui.extensionTags.hardware'
    },
    aiUse: {
        defaultMessage: 'AI Recognition',
        description: 'Extension category: ready-made AI recognition',
        id: 'gui.extensionTags.aiUse'
    },
    aiTrain: {
        defaultMessage: 'AI Training',
        description: 'Extension category: train your own model',
        id: 'gui.extensionTags.aiTrain'
    },
    data: {
        defaultMessage: 'Data',
        description: 'Extension category: data, charts, real-world data',
        id: 'gui.extensionTags.data'
    },
    tools: {
        defaultMessage: 'Tools',
        description: 'Extension category: pen, music, translate and other tools',
        id: 'gui.extensionTags.tools'
    }
});

export default [
    {tag: 'hardware', intlLabel: messages.hardware},
    {tag: 'ai-use', intlLabel: messages.aiUse},
    {tag: 'ai-train', intlLabel: messages.aiTrain},
    {tag: 'data', intlLabel: messages.data},
    {tag: 'tools', intlLabel: messages.tools}
];
